"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenterBox = CenterBox;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _styles = require("@mui/material/styles");
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function CenterBox(_ref) {
  var marginTop = _ref.marginTop,
    marginLeft = _ref.marginLeft,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: marginTop,
      marginLeft: marginLeft
    }
  }, children)));
}
CenterBox.propTypes = {
  marginLeft: _propTypes.default.string,
  marginTop: _propTypes.default.string,
  children: _propTypes.default.object
};